import React from 'react';

import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';

import Table from '../../../../Table';

import AddOrEditPageTabs from '../../../AddOrEditPageTabs';
import LoanService from '../../../../../services/LoanService';
import { useUiContext } from '../../../../../context/UiContext';
import ImpoundAnalysisService from '../../../../../services/ImpoundAnalysisService';

export default function ImpoundAnalyses({ loanId }) {
  const { showDialogModal, showToast } = useUiContext();

  const navigate = useNavigate();

  const { data: analyses, refetch } = useQuery({
    queryKey: ['impoundAnalyses', loanId],
    queryFn: () => LoanService.getLoanImpoundAnalyses(loanId),
    enabled: !!loanId,
  });

  const { mutate: deleteImpoundAnalysis } = useMutation({
    mutationFn: (impoundAnalysisId) =>
      ImpoundAnalysisService.deleteImpoundAnalysis(impoundAnalysisId),
    onSuccess: () => {
      showToast({
        text: 'Deleted',
        type: 'success',
      });
      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const cols = [
    {
      title: 'Date',
      keys: ['date'],
      type: 'date',
    },
    {
      title: 'Adjustment',
      keys: ['adjustment'],
      type: 'currency',
    },
    {
      title: 'Status',
      keys: ['status'],
      link: (row) =>
        `/loans/${row.loan_id}/impound-analyses/${row.id}?tab=Impound Analysis`,
    },
    {
      title: '',
      type: 'delete',
      onClick: (row) => {
        showDialogModal({
          title: 'Confirmation',
          type: 'danger',
          message: 'Are you sure want to delete this impound analysis?',
          onConfirm: () => deleteImpoundAnalysis(row.id),
          confirmButtonLabel: 'Yes, delete it',
          cancelButtonLabel: 'No, cancel',
        });
      },
    },
  ];

  const tabs = [
    {
      label: 'Schedule',
      activeOn: 'Impounds',
      onClick: () => navigate(`/loans/${loanId}?tab=Impounds`),
    },
    {
      label: 'Analysis',
      activeOn: 'Start Analysis',
    },
    {
      label: 'Initial',
    },
  ];

  return (
    <div>
      <div className="mb-4 flex justify-between md:items-center flex-col md:flex-row gap-2 h-[37px]">
        <AddOrEditPageTabs tabs={tabs} />
      </div>
      <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700">
        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold flex justify-between w-full mb-6">
          Impound Analyses
        </h2>
        <Table cols={cols} rows={analyses} title="" minHeight={565} />
      </div>
    </div>
  );
}
